<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                      <li class="tit_150">Subsidiary</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select id="selectRhqCd1" name="selectRhqCd1" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqCd ? (item.code == selectRhqCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select id="selectRhqSubCd1" name="selectRhqSubCd1" v-model="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqSubCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                    <ul class="w50">
                      <li class="tit_150">Content</li>
                      <li data-input-type="select" class="w100-150">
                        <select id="selectContentType" name="selectContentType" v-model="selectContentType" class="slt_white w100">
                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                            <option VALUE='Engineer'>Engineer</option>
                            <option VALUE='Customer'>Customer</option>
                        </select>
                      </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">
                            Period <em class="txt_mandatory">*</em>
                        </li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>                
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <!-- <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div> -->
                <div class="btn_wrap">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                     ref="GridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>

            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil, DateUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';


import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';
import UsagePopVue                         from '~va/statisticsManager/UsagePopVue.vue';


// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/byKnowledgeSearch.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid  renderer

class CustomRenderer {
    constructor(props) {
        let rowKey = props.rowKey;
        let resVal = props.value;
        let classChgYn = props.grid.store.data.rawData[rowKey].CLASS_YN;
        const el = document.createElement('span');
        if (resVal.indexOf("@TOTAL") > -1 ) {
            el.className = "ftbold";
            resVal = resVal.replace("@TOTAL","");
        }else{
            el.className = "ftColor";
            resVal = resVal.replace("@CONTENT","");
        }
        el.innerText = resVal;
        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            selectRhqCd: '',
            selectRhqNm: '',
            selectRhqSubCd: '',
            selectRhqSubNm: '',

            rhqCdList: [],
            rhqSubCdList: [],

            selectContentType : '',

            FROM_DATE: {},     
            TO_DATE: {},       

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId",
            gridKey: 0,
            gridData : [],
            columns : [
                {
                    header: "SUBSIDIARY_CD",
                    name: "SUBSIDIARY_CD",
                    hidden: true,
                },
                {
                    header: "LEFT_NM",
                    name: "LEFT_NM",
                    hidden: true,
                },
                {
                    header: "SEARCH_FROM_DATE",
                    name: "SEARCH_FROM_DATE",
                    hidden: true,
                },
                {
                    header: "SEARCH_TO_DATE",
                    name: "SEARCH_TO_DATE",
                    hidden: true,
                },
               
                {
                    header: "Content",
                    name: "LEFT_NM_CONV",
                    align: "left",
                    width: 353,
                    sortable: false,
                    resizable: false,
                },
                {
                    header: "Add(Approval)",
                    name: "K_ADD_CONV",
                    align: "right",
                    width: 225,
                    sortable: false,
                    resizable: false,
                },
                {
                    header: "Modify(Approval)",
                    name: "K_EDIT_CONV",
                    align: "right",
                    width: 225,
                    sortable: false,
                    resizable: false,
                },
                {
                    header: "K_VIEW",
                    name: "K_VIEW",
                    hidden: true,
                },
                {
                    header: "View",
                    name: "K_VIEW_CONV",
                    align: "right",
                    width: 225,
                    sortable: false,
                    resizable: false,
                    renderer: { type: CustomRenderer },

                },
                {
                    header: "Download",
                    name: "K_DOWNLOAD",
                    width: 225,
                    align: "right",
                    sortable: false,
                    resizable: false,
                },
            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },


    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        

        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        async getCodeComboList1(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';

            } else {
                this.getCodeComboList1(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = '';
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';

            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
            }
        },

        // 권한체크
        isAllUser(){
            
            if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`) || 
               this.getUserRole.includes(`${constants.GBM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.RHQ_ADMIN}`)) 
            {
                return true;
            }else{
                return false;
            }
            
        },

        // 버튼 이벤트
        async search(pageNo) {
            let validContents = this.registVerifyContents();
            if(validContents) {
                if (!pageNo) pageNo = 1;
                let params = {
                    RHQCD            : this.selectRhqCd,
                    RHQSUBCD         : this.selectRhqSubCd,
                    BOARDTYPE1NM     : this.selectContentType,
                    FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).formatWithJDF(
                                            moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy'),
                                        )
                                        : '',
                    TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(
                                            moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy'),
                                        )
                                        : '',
                };

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        //console.log('Yame',res);
                        let data = res.data;
                        this.totalCount = data.rowCount;
                        this.gridData = data.result;
                        this.gridKey++;
                        this.$nextTick(() => {
                            let idx = 0;    
                            for(let row of this.gridData){
                                if(row.LEFT_NM_CONV.indexOf("Total") >= 0 ) {
                                    this.$refs.GridId.addRowClassName(idx, 'sub_total');
                                }
                                idx++;
                            }
                        });
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> Grid
        contentClick(e, rowData, grid) {

            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData[e.rowKey];
            let menuName       = row['LEFT_NM'] || '';
            let subsidiaryCd   = row['SUBSIDIARY_CD'] || '';
            let searchFormDate = row['SEARCH_FROM_DATE'] || '';
            let searchToDate   = row['SEARCH_TO_DATE'] || '';
            let contentConv    = row['LEFT_NM_CONV'] || '';
            let kViewCnt       = row['K_VIEW'];
            console.log('kViewCnt',kViewCnt);
            // 컬럼별 이벤트 실행
            if( colNm === 'K_VIEW_CONV') {
                if(menuName !== null && contentConv.indexOf('Total') < 0 && kViewCnt > 0 ) {
                    SDLUtil.show(
                        UsagePopVue,
                        { popupType: 'Content' , keyNo: menuName, subsidiaryCd: subsidiaryCd , searchFormDate : searchFormDate , searchToDate : searchToDate },
                        { height: 'auto' }
                    );
                }
            } 
            
        },
       
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    const mFormat = localStorage.getItem('mDateFormat');
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/byKnowledgeExcel.skp`,
                            qs.stringify({
                                RHQCD        : this.selectRhqCd,
                                RHQSUBCD     : this.selectRhqSubCd,
                                BOARDTYPE1NM : this.selectContentType,
                                FROM_DATE    : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                                TO_DATE      : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        
        registVerifyContents() {
            let validList = [''];
            if(SDLUtil.isNull(this.rangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(SDLUtil.isNull(this.rangePicker.getEndDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },
    },
    created() {
        
    },

    mounted() {
        
        this.$nextTick(() => {
            this.getCodeComboList1(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                    this.selectRhqCd =  this.getLoginRHQCd;
                });

            this.getCodeComboList1(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = this.getLoginCompanyCd;
                });
            
            let toDate = new Date();    
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            //this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
            //this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());    
            this.rangePicker = DatePicker.createRangeWithOpener(
                            'from-picker-container', 'fromDate', 'icoFromDate',
                            'to-picker-container', 'toDate', 'icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-1, 'month').toDate(),
                            (new moment()).toDate()
            );
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
    /*  사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important;}
.ftbold  {font-weight: bold!important;}
.sub_total {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 40px !important;
}
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/byKnowledgeList.vue